// 商品表现
const state = {
  formTime: []
}

const mutations = {
  SET_FORM_TIME: (state, data) => {
    state.formTime = data
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
